import { toast, ToastOptions } from 'react-toastify';
import { isAxiosError } from 'axios';

// This function prioritizes the toastId from the Axios error response over the one passed in options
export const toastError = (
  {
    error,
    axiosMessage = 'Something went wrong',
    appMessage,
  }: {
    error: unknown;
    axiosMessage?: string;
    appMessage?: string;
  },
  options?: ToastOptions,
) => {
  if (isAxiosError(error)) {
    const toastId = error?.response?.data?.toastId;
    toast.error(error?.response?.data?.message ?? axiosMessage, {
      ...options,
      toastId,
    });
  } else {
    toast.error(appMessage ?? axiosMessage, options);
  }
};

export const toastSuccess = (
  successMessage: string,
  options?: ToastOptions,
) => {
  toast.success(successMessage, options);
};

export const toastWarning = (
  warningMessage: string,
  options?: ToastOptions,
) => {
  toast.warning(warningMessage, options);
};

export const toastInfo = (infoMessage: string, options?: ToastOptions) => {
  toast.info(infoMessage, options);
};
